import { createDecorator } from 'vue-class-component';

export const meta = createDecorator((options, key) => {
  if (!options.methods) {
    return;
  }
  options.metaInfo = options.methods[key];
});
